import * as React from 'react';
import { ThemeConfig } from 'docz';
import styled from 'react-emotion';
import { Sidebar, Main } from '../shared';
import { get } from '@utils/theme';
const Wrapper = styled('div') `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - var(--colorbar-height));
  color: ${get('colors.text')};
  background: ${get('colors.background')};
`;
const Title = styled('h1') `
  margin: 0;
  font-size: 42px;
  font-weight: 400;
  color: ${get('colors.primary')};
`;
const Subtitle = styled('p') `
  margin: 0;
  font-size: 18px;
`;
export const NotFound = () => (React.createElement(ThemeConfig, null, config => (React.createElement(Main, { config: config },
    React.createElement(Sidebar, null),
    React.createElement(Wrapper, null,
        React.createElement(Title, null, "Page Not Found"),
        React.createElement(Subtitle, null, "Check if you haven't changed the document route or deleted it!"))))));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm90Rm91bmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY29tcG9uZW50cy91aS9Ob3RGb3VuZC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUE7QUFDOUIsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLE1BQU0sQ0FBQTtBQUNsQyxPQUFPLE1BQU0sTUFBTSxlQUFlLENBQUE7QUFFbEMsT0FBTyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFDekMsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUVsQyxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7Ozs7Ozs7V0FPbEIsR0FBRyxDQUFDLGFBQWEsQ0FBQztnQkFDYixHQUFHLENBQUMsbUJBQW1CLENBQUM7Q0FDdkMsQ0FBQTtBQUVELE1BQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTs7OztXQUlmLEdBQUcsQ0FBQyxnQkFBZ0IsQ0FBQztDQUMvQixDQUFBO0FBRUQsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBOzs7Q0FHM0IsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLFFBQVEsR0FBRyxHQUFHLEVBQUUsQ0FBQyxDQUM1QixvQkFBQyxXQUFXLFFBQ1QsTUFBTSxDQUFDLEVBQUUsQ0FBQyxDQUNULG9CQUFDLElBQUksSUFBQyxNQUFNLEVBQUUsTUFBTTtJQUNsQixvQkFBQyxPQUFPLE9BQUc7SUFDWCxvQkFBQyxPQUFPO1FBQ04sb0JBQUMsS0FBSyx5QkFBdUI7UUFDN0Isb0JBQUMsUUFBUSx5RUFFRSxDQUNILENBQ0wsQ0FDUixDQUNXLENBQ2YsQ0FBQSJ9